<template>
  <div class="app">
    <el-carousel trigger="click" :autoplay="true">
      <el-carousel-item>
        <div class="lunimg">
          <img src="@/assets/images/home/sy_banner_bg.png" />
        </div>
        <div class="luncenter center-wrap homefirstlunbo">
          <div>业界领先的声纹识别、语音智能与音频大数据技术</div>
          <div>旨在实现一种智能：听得清楚、感知灵敏、识别准确、响应迅速</div>
          <div class="homelookmore" @click="goto('coreTechnology')">
            查看详情
          </div>
          <!-- <img  src="@/assets/images/chanpin/swhz.png" /> -->
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <banner class="banner1" :Product="product_rs"></banner>
      </el-carousel-item>
      <el-carousel-item>
        <banner class="banner2" :Product="product_hs"></banner>
      </el-carousel-item>
    </el-carousel>
    <!--主体部分-->
    <div class="w100 hx">
      <div class="title">
        <h4>核心技术</h4>
        <p>致力于声纹识别与语音智能技术服务</p>
      </div>
      <div class="hx_display">
        <div class="content">
          <div class="item" v-for="(item, index) in coretescMsg" :key="index">
            <img :src="require('@/assets/' + item['img'])" />
            <p class="subt">{{ item["h3"] }}</p>
            <p v-for="(ite, ind) in item['p']" :key="ind">{{ ite }}</p>
          </div>
        </div>
        <p class="konwmore"></p>
        <div class="moreCoretech" @click="goto('coreTechnology')">
          了解更多>
        </div>
        <div style="height: 89px"></div>
      </div>
    </div>

    <div class="w100 product clearfix">
      <div class="title">
        <h4>产品</h4>
        <p>让安全听得见</p>
      </div>
      <div class="content2">
        <div
          class="box box-product"
          v-for="(item, index) in products"
          :key="index"
        >
          <div v-if="item['right'] !== true">
            <img :src="require('@/assets/' + item['banner'])" />
          </div>
          <div>
            <div class="des" style="position: relative">
              <h4>{{ item["h4"] }}</h4>
              <div
                class="product_ product_sm"
                :style="{
                  background:
                    'url(' +
                    require('@/assets/' + item['product_img']) +
                    ') no-repeat'
                }"
              ></div>
              <span class="reg">&reg;</span>
              <div class="product-p">
                <p v-for="(ind, ins) in item['p']" :key="ins">{{ ind }}</p>
              </div>
              <div class="lookmore" @click="goto(item['path'])">查看详情</div>
              <div
                class="downloadMore"
                @click="download(item['path'])"
                :style="{
                  background:
                    'url(' +
                    require('@/assets/images/home/sy_xz.png') +
                    ') no-repeat'
                }"
              ></div>
            </div>
          </div>
          <div v-if="item['right'] === true">
            <img :src="require('@/assets/' + item['banner'])" />
          </div>
        </div>
      </div>
      <div class="moreCoretech" @click="goto('SoundSafe')">了解更多></div>
      <div style="height: 89px"></div>
      <!-- <a href="sm.html">了解更多></a> -->
    </div>

    <div class="w100 w_bg">
      <div class="center">
        <h3>声纹识别、语音智能与智能可信物联网</h3>
        <p class="cp">
          Voiceprint Recognition, Voice Intelligence and AI Internet of Trusted
          Things
        </p>
      </div>
    </div>
    <!-- 行业应用 -->
    <div class="w100 using">
      <div class="title">
        <h4>行业应用</h4>
        <p>建设更加安全与便利的社会</p>
      </div>
      <div class="content2 yingyong clearfix">
        <div class="box" v-for="(item, index) in uses" :key="index">
          <img
            v-if="item['right'] !== true"
            :src="require('@/assets/' + item['banner'])"
          />
          <div class="box-other" v-if="item['right'] !== true"></div>
          <div>
            <h4 class="comtentboxh4">
              {{ item["h4"] }}
              <span class="shade">{{ item["shade"] }}</span>
            </h4>
            <div class="cont-p">
              <!-- <p v-for="(ite, ind) in item['p']" :key="ind">{{ite}}</p> -->
              <p>{{ item["p"] }}</p>
            </div>
          </div>
          <div class="box-other" v-if="item['right'] === true"></div>
          <img
            v-if="item['right'] === true"
            :src="require('@/assets/' + item['banner'])"
          />
        </div>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <!-- <Partnership></Partnership> -->
    <introduction></introduction>
  </div>
</template>

<script>
import Footer from "@/components/layout/Footer";
import Header from "@/components/layout/Header";
import Partnership from "@/components/common/Partnership";
import introduction from "@/components/common/introduction";
import banner from "./banner";
import { BaseURL } from "@/api/http.js";
export default {
  data() {
    return {
      product_rs: {
        background: "images/chanpin/rs_banner.png",
        img: "images/chanpin/rs_ct.png",
        name: "SoundDenoise",
        desc: [],
        h2: [],
        h3: ["语音降噪与增强系统"],
        p: ["独特地组合了十几种先进的", "智能降噪算法的音频处理工具箱"],
        product: "images/chanpin/sb_rs.png"
      },
      product_hs: {
        background: "images/chanpin/hs_banner.png",
        name: "SoundDetect",
        img: "images/chanpin/hs_ct.png",
        desc: [],
        h2: [],
        h3: [
          "面向海量音频数据筛选与",
          "分析任务场景的智能分析平台及配套工具集"
        ],
        p: [],
        product: "images/chanpin/sb_hs.png"
      },
      coretescMsg: [
        {
          img: "images/home/hx1.png",
          h3: "声纹识别",
          p: ["说话人识别，听音识人"]
        },
        {
          img: "images/home/hx2.png",
          h3: "语音关键字定位",
          p: ["在音频文件中搜索定位语音关键字"]
        },
        {
          img: "images/home/hx3.png",
          h3: "语种与方言识别",
          p: ["识别说话人的语言或方言"]
        },
        {
          img: "images/home/hx4.png",
          h3: "性别与年龄段识别",
          p: ["识别说话人的性别和年龄段"]
        },
        {
          img: "images/home/hx5.png",
          h3: "语音指令识别技术",
          p: ["语音指令驱动机器"]
        },
        {
          img: "images/home/hx6.png",
          h3: "语音活动检测技术",
          p: ["音频中说话语音自动提取"]
        },
        {
          img: "images/home/hx7.png",
          h3: "语音降噪与增强技术",
          p: ["去除语音音频里的噪声"]
        },
        {
          img: "images/home/hx8.png",
          h3: "音频处理与分析技术",
          p: ["音频数字化与变换处理", "音频与语音特征处理、分析与展现"]
        }
      ],
      products: [
        {
          right: true,
          h4: "—基于语音的远程身份验证系统",
          product_img: "images/home/sy_sm.png",
          p: [
            "面向移动应用、呼叫中心等身份识别场景，",
            "基于声纹及语音指令识别的多模身份验证方案"
          ],
          path: "SoundSafe",
          banner: "images/product1.png"
        },
        {
          right: false,
          h4: "系列—音频数据智能分析系统",
          product_img: "images/home/sy_hs.png",
          p: [
            "面向海量音频数据筛查与分析任务场景的智能分析平台",
            "及配套工具集"
          ],
          path: "SoundScriber",
          banner: "images/home/sy_hs2.png"
        },
        {
          right: true,
          h4: "系列—声纹库及搜索比对系统",
          product_img: "images/home/sy_hs.png",
          p: ["面向公共安全的声纹库及搜索比对服务平台"],
          path: "SoundDetect",
          banner: "images/product2.png"
        },
        {
          right: false,
          h4: "系列—语音降噪与增强系统",
          product_img: "images/home/sy_rs.png",
          p: [
            "独特地组合了十几种先进的智能降噪与",
            "语音增强算法的音频降噪处理工具箱"
          ],
          path: "SoundDenoise",
          banner: "images/product3.png"
        },
        {
          right: true,
          h4: "—语音声纹采集工作站",
          product_img: "images/home/sy_sj.png",
          p: ["桌面式拾音器及配套PC采集软件"],
          path: "SoundCapture",
          banner: "images/home/sy_sj_ct.png"
        }
      ],
      uses: [
        {
          right: true,
          h4: "公共安全",
          shade: "01 Public safety",
          p:
            "大晟极绘晟系列产品，能跨复杂语音信道及数据网络实施远程、非接触式目标人识别、语音画像、海量音频分析，为反恐、案件侦破、安全保障、身份查询等业务提供更加安全、快捷的技术手段，有效遏制与打击犯罪。",
          banner: "images/index/hyyy_ct_a.png"
        },
        {
          right: false,
          h4: "政企",
          shade: "02 G^B",
          p:
            "大晟极可通过声纹识别、语音关键字定位、语音指令识别、情绪识别，为呼叫中心、客服系统、电话会议等场景提供智能语音解决方案，实现快速识别来电人身份，话务转接，会议纪要以及服务智能分析评价，优化提升服务质量和效率。",
          banner: "images/index/yy2.png"
        },
        {
          right: true,
          h4: "金融",
          shade: "03 Finance",
          p:
            "大晟极晟密系列产品，为银行、证券、保险、互联网金融等机构提供可用于热线电话、移动APP、智能硬件等场景下的客户身份认证、黑名单人员识别预警，防范身份欺诈，提高电话客服的服务满意度，降低移动互联网金融账户操作风险。",
          banner: "images/index/hyyy_ct_b.png"
        },
        {
          right: false,
          h4: "社保",
          shade: "04 Social insurance",
          p:
            "大晟极晟密系列产品，可实现参保人员通过电话、微信语音等通信方式进行远程身份与生存验证，智能语音交互实现验证全自动化。产品方案能防录音攻击并支持活体检测，杜绝骗保等行为，避免养老金流失。",
          banner: "images/index/yy4.png"
        },
        {
          right: true,
          h4: "智能安防",
          shade: "05 Intelligent security",
          p:
            "大晟极音频监控解决方案，让安防更加智慧，从“看得到”发展到“听得到”安全事件更能及时感知、预警和处置，社会安全风险得到降低。",
          banner: "images/index/yy5.png"
        },
        {
          right: false,
          h4: "智能硬件",
          shade: "06 Intelligent hardware",
          p:
            "大到无人系统、智能家居、小到个人穿戴设备的远程语音操控，大晟极携带身份的语音指令系统能做到兼具安全性和高效性。",
          banner: "images/index/hyyy_ct_c.png"
        }
      ]
    };
  },
  methods: {
    // 查看更多
    goto(name) {
      this.$router.push({ name: name });
    },
    download() {
      const name = "彩页图";
      const url = BaseURL + "materials/downloadByName?typeName=" + name;
      // const url = "/file/exportDetail.do?id=" + id;
      window.open(url);
    }
  },
  components: {
    Footer: Footer,
    Header: Header,
    Partnership,
    introduction,
    banner
  }
};
</script>

<style scoped>
.app /deep/ .el-carousel {
  /* box-sizing: border-box; */
  /* margin: 0; */
  margin-top: -62px;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  list-style: none;
}

.app /deep/ .el-carousel__container {
  position: relative;
  height: 530px;
}

/* 轮播图开始 */
.lunimg img {
  margin-bottom: -162px;
  /* width: 100%;
  height: 584px; */
}

.homelookmore {
  width: 160px;
  line-height: 50px;
  background: linear-gradient(86deg, #7460ee, #fc487a);
  border-radius: 4px;
  font-size: 20px;
  font-weight: 500;
  color: #fff;
  display: inline-block;
}

.luncenter {
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  /* margin-top: -180px; */
}

.homefirstlunbo {
  font-size: 34px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  margin-top: -245px;
  width: 1100px;
  /* position: absolute;
  left: 365px;
  top: 245px; */
}

.homefirstlunbo :first-child {
  text-align: center;
}

.homefirstlunbo :nth-child(2) {
  text-align: center;
  margin-top: 40px;
}

.homefirstlunbo :nth-child(3) {
  text-align: center;
  margin-top: 85px;
}

.luncenter h2 {
  font-size: 50px;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  margin-top: -220px;
  margin-bottom: 160px;
}

.joinus {
  width: 200px;
  height: 60px;
  border: 1px solid rgba(255, 255, 255, 1);
  display: inline-block;
  font-size: 18px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 56px;
}

.luncenter p {
  height: 20px;
  font-size: 18px;
  font-weight: 400;
  /* padding-top: 40px; */
  margin-bottom: 100px;
}

.banner1 /deep/ .product-h3 {
  font-size: 40px;
}

.banner2 /deep/ .product-h3 {
  font-size: 30px;
  line-height: 40px;
  width: 700px;
}

.banner1 /deep/ .product-p {
  font-size: 24px;
  line-height: 33px;
}

.luncenter h5 {
  font-size: 28px;
  color: rgba(255, 255, 255, 1);
  font-weight: 400;
  line-height: 28px;
  margin-top: -105px;
  margin-bottom: 97px;
}

/* 轮播图结束 */
.moreCoretech {
  width: 90px;
  height: 34px;
  border: 1px solid rgba(219, 219, 219, 1);
  border-radius: 14px;
  line-height: 34px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  margin-top: 45px;
}

/* 核心技术 */
.content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: block;
  width: 1000px;
  height: 550px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  min-width: 979px;
}

.content .subt {
  height: 21px;
  width: 250px;
  margin-top: 5px;
  font-size: 24px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
}

.content p {
  font-size: 14px;
  width: 250px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  margin-top: 0px;
}

.hx_display .item img {
  height: 166px;
  width: 166px;
}

.item {
  float: left;
  margin-top: 80px;
  width: 250px;
  /* width: 250px; */
  margin-bottom: 24px;
}

.content .subt {
  height: 21px;
  margin-top: 5px;
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 10px;
  color: rgba(51, 51, 51, 1);
}

/* 我们的产品开始 */
.title p {
  font-size: 18px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  margin-top: 19px;
}

.app .content2 {
  width: 1050px;
}

.app .yingyong {
  width: 1050px;
}

.box-product {
  width: 1040px;
}

.content2 .box h4 {
  white-space: nowrap;
  overflow: initial;
  padding-left: 82px;
  font-weight: bold;
}

.content2 .box div > img {
  width: 415px;
  margin-top: -129px;
}

.product .box p {
  font-size: 20px;
  line-height: 26px;
  margin-top: 0px;
  color: rgb(82, 72, 72);
  width: 550px;
}

.product_ {
  width: 61px;
  height: 29px;
  background-size: cover;
  position: absolute;
}

.product_sm {
  top: 1px;
  /* left: 364px; */
}

.product-p {
  position: absolute;
  margin-top: 20px;
}

.reg {
  position: absolute;
  left: 0px;
  top: 0px;
  margin-left: 67px;
  margin-top: -9px;
  font-size: 14px;
}

.product_hs {
  /* background: url(@/assets/images/home/sy_hs.png) no-repeat; */
  top: 3px;
}

.product_rs {
  /* background: url(@/assets/images/home/sy_rs.png) no-repeat; */
  top: 3px;
}

.lookmore {
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  width: 100px;
  height: 42px;
  line-height: 42px;
  background: rgba(74, 17, 118, 1);
  border-radius: 16px;
  top: 125px;
  left: 0px;
  position: absolute;
}

.downloadMore {
  width: 42px;
  height: 42px;
  border: 1px solid rgba(216, 216, 216, 1);
  border-radius: 16px;
  /* background: url(@/assets/images/home/sy_xz.png) no-repeat; */
  top: 125px;
  left: 111px;
  position: absolute;
}

/* 我们的产品结束 */
.center h3 {
  font-size: 50px;
  font-weight: bold;
  line-height: 37px;
}

.con-p {
  width: 620px;
}

.content2 .box {
  display: inline-block;
  height: 265px;
}

.content2 .box .comtentboxh4 {
  padding-left: 0px;
}

.content2 .box > div {
  float: left;
}

.content2 {
  padding-top: 150px;
  width: 1200px;
  min-width: 1040px;
}

.using .box > div {
  /* width: 43.8%; */
  width: 480px;
  float: left;
  margin: 0;
}

.using .box img {
  width: 480px;
  margin-left: 0px;
  margin-right: 0px;
  float: left;
}

.using .content2 p {
  line-height: 26px;
  font-size: 16px;
  font-weight: normal;
  color: rgba(153, 153, 153, 1);
}

.box-other {
  width: 90px !important;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/home/home.vue